import React, { useEffect, useState } from "react";
import { gql, useLazyQuery } from "@apollo/client";
import AdminCardHint from "./cardMessage";
import AdminUsersHint from "./usersMessage";
import { useLocation } from "react-router-dom";
import LineChart from "@general/lineChart";
import { Row, Col, Divider, Radio, Space } from "antd";
import BarChart from "@general/barChart";
import AdminConsultationsHint from "./consultationMessage";
import DatePicker from "@general/datePicker";
import moment from "moment-jalaali";

const { RangePicker } = DatePicker;

function AdminDashboard(props) {
  const ADMINDASHBOARDDATA = gql`
    query adminDashboardData(
      $confirmStatus: ConfirmStatus!
      $cardStatus: CardStatus!
      $chartTime: ChartTime!
      $financialChartSearchInput: FinancialChartSearchInput
    ) {
      getPurchasesCount(searchInput: { isNewConsultation: true })
      getUsersCount(searchInput: { confirmStatus: [$confirmStatus] })
      getCardsCount(searchInput: { cardStatus: [$cardStatus] })
      getFunancialChart(
        searchInput: $financialChartSearchInput
        chartTime: $chartTime
      ) {
        labels
        incomesValues
        expendituresValues
        profitsValues
      }
    }
  `;
  const [pendingUsersCount, setPendingUsersCount] = useState(null);
  const [issuingCardsCount, setIssuingCardsCount] = useState(null);
  const [chartLabels, setChartLabels] = useState();
  const [expendituresValues, setExpendituresValues] = useState();
  const [incomesValues, setIncomesValues] = useState();
  const [profitsValues, setProfitsValues] = useState();
  const [consultationsCount, setConsultationsCount] = useState(0);
  const [chartTime, setChartTime] = useState("MONTHLY");
  const [filterDateFrom, setFilterDateFrom] = useState(null);
  const [filterDateTo, setFilterDateTo] = useState(null);

  const handleDateRangeChange = (dates, dateStrings) => {
    if (!dateStrings || !dateStrings[0] || !dateStrings[1]) {
      setFilterDateFrom(null);
      setFilterDateTo(null);
    } else {
      setFilterDateFrom(
        moment(dateStrings[0], "jYYYY/jMM/jDD")
          .startOf("day")
          .toDate()
          .toISOString()
      );
      setFilterDateTo(
        moment(dateStrings[1], "jYYYY/jMM/jDD")
          .endOf("day")
          .toDate()
          .toISOString()
      );
    }
  };

  const [getAdminData, adminData] = useLazyQuery(ADMINDASHBOARDDATA, {
    fetchPolicy: "no-cache",
    onCompleted({
      getUsersCount,
      getCardsCount,
      getFunancialChart,
      getPurchasesCount: newConsultationsCount,
    }) {
      setPendingUsersCount(getUsersCount);
      setIssuingCardsCount(getCardsCount);
      setChartLabels(getFunancialChart?.labels);
      setExpendituresValues(getFunancialChart?.expendituresValues);
      setIncomesValues(getFunancialChart?.incomesValues);
      setProfitsValues(getFunancialChart?.profitsValues);
      setConsultationsCount(newConsultationsCount);
    },
    onError(err) {
      console.log("خطا: " + err);
    },
  });
  const location = useLocation();
  useEffect(() => {
    getAdminData({
      variables: {
        confirmStatus: "PENDING",
        cardStatus: "ISSUING",
        chartTime,
        financialChartSearchInput:
          filterDateFrom && filterDateTo
            ? { occurrenceAt: [filterDateFrom, filterDateTo] }
            : {},
      },
    });
  }, [location.pathname, chartTime, filterDateFrom, filterDateTo]);
  return (
    <>
      <Row gutter={[30, 30]}>
        <Col xs={24} md={12}>
          <AdminUsersHint pendingUsersCount={pendingUsersCount} />
          <AdminCardHint issuingCardsCount={issuingCardsCount} />
          <AdminConsultationsHint consultationsCount={consultationsCount}/>
        </Col>
        </Row>
        {pendingUsersCount||issuingCardsCount||consultationsCount ? <Divider/> : null}
      <Row gutter={[30, 30]}>
        <Col xs={24} md={18}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "12px",
              marginBottom: "16px",
            }}
          >
            <Radio.Group
              value={chartTime}
              onChange={(e) => setChartTime(e.target.value)}
              buttonStyle="solid"
            >
              <Radio.Button value="MONTHLY">ماهانه</Radio.Button>
              <Radio.Button value="DAILY">روزانه</Radio.Button>
            </Radio.Group>
            <Space>
              <RangePicker
                placeholder={["از تاریخ", "تا تاریخ"]}
                onChange={handleDateRangeChange}
              />
            </Space>
          </div>
          <LineChart
            labels={chartLabels}
            firstChartValues={expendituresValues}
            secondChartValues={incomesValues}
          />
          <BarChart labels={chartLabels} values={profitsValues} />
        </Col>
      </Row>
    </>
  );
}

export default AdminDashboard;
